class SiteElementFilterSingleArticleGroupRenderer
    extends QueryElement<HTMLElement>
    implements ISiteElementFilterRenderer {
    
    private readonly _filter: SiteElementFilterSingle;
    private readonly _value: ISiteFilterItem;
    private readonly _site: SiteAssortment;
    
    constructor(filter: SiteElementFilterSingle, value: ISiteFilterItem, site: SiteAssortment) {
        super(document.createElement("DIV"));

        this._filter = filter;
        this._value = value;
        this._site = site;

        this.addClass("menu-large")
            .addClass("articlegroups")
            .addClass("element-hover");
        
        this.append(QueryElement.QueryElement("I")
            .addClass("element-hover-close")
            .setText("menu"));
        this.append(this.renderChilds(value.items).container);

        var element = this.get();
        if (element == null)
            throw "Unable to get element";
        
        new SiteElementHover(element);
    }

    renderChilds(values: ISiteFilterItemValue[]) {

        let container = QueryElement.QueryElement("UL");

        let isActive = false;
        
        for(let item of values) {
            let id = `${item.filterValue.split("/")[1]}-${item.name}`;
            let meActive = id == this._filter.getValue();

            let containerItem = QueryElement.QueryElement("LI").addClass("element-hover");

            var element = containerItem.get();
            if (element == null)
                throw "Unable to get element";
        
            new SiteElementHover(element);

            let containerUrl = QueryElement.QueryElement("SPAN")
                .appendTo(containerItem);
            
            containerUrl.setText(item.name);
            containerUrl.on('click', e => {
                this.setValue(id);
                e.stop();
            });
        
            
            if (item.childs != null) {
                let result = this.renderChilds(item.childs);
                containerItem.append(result.container);
                
                // Check if inner child was active
                if (result.isActive == true)
                    meActive = true;
            }

            if (meActive)
                containerItem.addClass("active");
            
            if (!isActive)
                isActive = meActive;

            container.append(containerItem);
        }

        return {
            container: container,
            isActive: isActive
        };
    }
    setValue(id: string) {
        this._filter.clearFilterModel();
        this._filter.setValue(id);
        this._filter.updateFilterModel(true);
    }

    getState() {
        return null;
    }
}